import { LOCAL_STORAGE_KEY } from 'constants/localStorage';
import ls from 'local-storage';

import UsersAPI from '../../api/UsersAPI';
import {
  authInitFailed,
  authInitSuccess,
  createUser_,
  createUserFailed,
  createUserSuccess,
  deleteUser_,
  deleteUserFailed,
  deleteUserSuccess,
  loadUsers_,
  loadUsersFail,
  loadUsersSuccess,
  onAuthFailed,
  onLoggedIn,
  onLoggedOut,
  onLogoutFail,
  refetchCurrentUserFail,
  refetchCurrentUserSuccess,
  startAuthInit,
  startLoggingIn,
  startLoggingOut,
  startRefetchCurrentUser,
  updateUser_,
  updateUserFail,
} from './actions';

export function logIn(data) {
  return (dispatch) => {
    dispatch(startLoggingIn());
    return UsersAPI.login(data.email, data.password)
      .then(user => {
        dispatch(onLoggedIn(user));
        return { user };
      })
      .catch(error => {
        dispatch(onAuthFailed(error));
        return { error: error.response?.data?.message || 'Something went wrong' };
      });
  };
}

export function signUp(data, marketingData = {}) {
  return (dispatch) => {
    dispatch(startLoggingIn());

    return UsersAPI.signup(data.email, data.password, marketingData).then(
      user => {
        dispatch(onLoggedIn(user.user));
        return { user: user.user, registrationCompletedWithLogin: user.registrationCompletedWithLogin };
      },
      error => dispatch(onAuthFailed(error))
    );
  };
}

export function logOut() {
  return (dispatch, getState) => {
    var usersState = getState().users;
    if (usersState.currentUserId == undefined) {
      return Promise.resolve();
    }
    dispatch(startLoggingOut());
    return UsersAPI.logout().then(
      () => dispatch(onLoggedOut()),
      () => dispatch(onLogoutFail())
    );
  };
}

export function initializeAuthorization() {
  return (dispatch) => {
    dispatch(startAuthInit());
    return UsersAPI.getMe().then(
      d => {
        dispatch(authInitSuccess(d));
        ls.set(LOCAL_STORAGE_KEY.EMAIL_VERIFICATION_DATE, d?.emailVerifiedAt);
        return { user: d };
      },
      () => {
        dispatch(authInitFailed());
        return { user: undefined };
      }
    );
  };
}

export function refetchCurrentUser() {
  return (dispatch, getState) => {
    const { currentUserId } = getState().users;
    if (!currentUserId) {
      return Promise.resolve();
    }
    dispatch(startRefetchCurrentUser());
    return UsersAPI.getMe().then(
      user => {
        dispatch(refetchCurrentUserSuccess(user));
      },
      error => {
        dispatch(refetchCurrentUserFail(error));
      }
    );
  };
}

export function loadUserById(id) {
  return (dispatch) => {
    dispatch(loadUsers_());
    return UsersAPI.getUser(id).then(
      u => dispatch(loadUsersSuccess([u])),
      error => dispatch(loadUsersFail(error))
    );
  };
}

export function loadUsersByIds(ids) {
  return (dispatch) => {
    dispatch(loadUsers_());
    return UsersAPI.getUsersByIds(ids).then(
      users => dispatch(loadUsersSuccess(users)),
      error => dispatch(loadUsersFail(error))
    );
  };
}
// TODO: remove this function if it's not used

// export function loadLimboUsers() {
//   return (dispatch, getState) => {
//     dispatch(loadUsers_());
//     return SlidesAPI.getLimboUsers().then(
//       users => dispatch(loadUsersSuccess(users)),
//       error => dispatch(loadUsersFail(error))
//     );
//   };
// }

export const updateUserSuccess = user => {
  return {
    type: 'UPDATE_USER_SUCCESS',
    user: user
  };
};

export function updateUser(data) {
  return (dispatch) => {
    // let {currentUserId, usersMap} = getState().users;
    // data.id = currentUserId;
    dispatch(updateUser_());
    return UsersAPI.updateUser(data).then(
      user => dispatch(updateUserSuccess(user)),
      err => dispatch(updateUserFail(err))
    );
  };
}

//load all users
export function loadAllUsers() {
  return (dispatch) => {
    dispatch(loadUsers_());
    return UsersAPI.getAllUsers().then(
      users => dispatch(loadUsersSuccess(users)),
      err => dispatch(loadUsersFail(err))
    );
  };
}

export function loadAllTeachers() {
  return (dispatch) => {
    dispatch(loadUsers_());
    return UsersAPI.getAllTeachers().then(
      users => dispatch(loadUsersSuccess(users)),
      err => dispatch(loadUsersFail(err))
    );
  };
}

export function createUser(data) {
  return (dispatch) => {
    dispatch(createUser_());
    return UsersAPI.createUser(data).then(
      user => dispatch(createUserSuccess(user)),
      error => dispatch(createUserFailed(error))
    );
  };
}

export function deleteUser() {
  return (dispatch) => {
    dispatch(deleteUser_());
    return UsersAPI.deleteUser().then(() => dispatch(deleteUserSuccess()),
      error => dispatch(deleteUserFailed(error))
    );
  };
}
